import { useScrollLock } from '@vueuse/core';

let modalStackCount = 0;
let isBodyScrollLocked: ReturnType<typeof useScrollLock> | null = null;

export function useModalStack() {
  if (!isBodyScrollLocked && typeof document !== 'undefined') {
    isBodyScrollLocked = useScrollLock(document.body);
  }

  const registerModal = () => {
    modalStackCount++;
    if (isBodyScrollLocked) {
      isBodyScrollLocked.value = true;
    }
  };

  const unregisterModal = () => {
    modalStackCount = Math.max(0, modalStackCount - 1);
    if (isBodyScrollLocked) {
      isBodyScrollLocked.value = modalStackCount > 0;
    }
  };

  return {
    registerModal,
    unregisterModal,
  };
}
